function Page404(){
    return(
        <div className={`custom-chatapp-chatbot`}>
            <div className="custom-chatapp-frame-content custom-chatapp-404" style={{background: `url('/assets/images/404.jpg') no-repeat center center #fff`}}>
            </div>
        </div>
    );
}

export default Page404;